import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { nebankaRoute } from '../route';

export const nebankaProductsRoute = createRoute({
	getParentRoute: () => nebankaRoute,
	path: '/products',
	component: lazyRouteComponent(
		() => import('./NebankaProductsPage'),
		'NebankaProductsPage',
	),
});
